import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-taballow",
  "use": "icon-taballow-usage",
  "viewBox": "0 0 2413 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2413 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-taballow\"><path d=\"M2413.714286 504.685714L1546.971429 0v340.114286H0v343.771428h1546.971429V1024z\" p-id=\"23866\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol